import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface DarkCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  watermark?: string;
  icon?: React.ReactNode;
}
export function DarkCard({
  title,
  subtitle,
  children,
  watermark,
  icon
}: DarkCardProps) {
  return <div className="relative bg-rise-black border border-rise-gold/40 rounded-xl overflow-hidden p-8 md:p-[40px] h-full flex flex-col" data-id="element-113" data-mp="d1warxx6chtd">
      <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold" data-id="element-114" data-mp="3veu6fsmxoohq"></div>
      {watermark && <div className="absolute -bottom-4 -right-4 text-[120px] font-playfair text-white/[0.03] leading-none pointer-events-none select-none" data-id="element-115" data-mp="43bzvixuvcfp">
          {watermark}
        </div>}
      {icon && <div className="mb-6 text-rise-gold" data-id="element-116" data-mp="3qi3o0ynnpgt5">{icon}</div>}
      {subtitle && <div className="text-rise-white/60 uppercase tracking-wider text-[13px] font-dm-sans mb-2" data-id="element-117" data-mp="3chaw8loqoztq">
          {subtitle}
        </div>}
      <h3 className="text-rise-gold font-playfair text-[20px] md:text-[22px] mb-4 relative z-10" data-id="element-118" data-mp="3hiqek5zj8s8f">
        {title}
      </h3>
      <div className="text-rise-white/80 font-dm-sans text-[16px] leading-relaxed relative z-10 flex-grow" data-id="element-119" data-mp="3qbaej49nfq0c">
        {children}
      </div>
    </div>;
}
interface LightCardProps {
  title: string;
  children: React.ReactNode;
}
export function LightCard({
  title,
  children
}: LightCardProps) {
  return <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 md:p-[40px] h-full flex flex-col" data-id="element-120" data-mp="3bm4jztlranys">
      <h3 className="text-rise-black font-playfair text-[20px] md:text-[22px] mb-4" data-id="element-121" data-mp="36nt8leftc5eg">
        {title}
      </h3>
      <div className="text-rise-gray font-dm-sans text-[16px] leading-relaxed flex-grow" data-id="element-122" data-mp="3lch63q97yp71">
        {children}
      </div>
    </div>;
}
export function CheckListItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-3 mb-4 last:mb-0" data-id="element-123" data-mp="2subsy4q8zctp">
      <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-124" data-mp="2nxblpqhnw410" />
      <span className="font-dm-sans text-[16px] leading-relaxed" data-id="element-125" data-mp="rtopgpttq17g">
        {children}
      </span>
    </div>;
}